import { render } from "./BrowseFile.vue?vue&type=template&id=b202867c&scoped=true"
import script from "./BrowseFile.vue?vue&type=script&lang=js"
export * from "./BrowseFile.vue?vue&type=script&lang=js"

import "./BrowseFile.vue?vue&type=style&index=0&id=b202867c&scoped=true&lang=css"
import "./BrowseFile.vue?vue&type=style&index=1&id=b202867c&lang=scss"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b202867c"]])

export default __exports__